import { addHours, addMinutes, getUnixTime } from 'date-fns';
import { canTransferJobToCustomer } from '../shared/helpers/conditionalTransferHelpers';
import { addTimeZoneOffset } from '../shared/helpers/removeTimeZoneOffset';
import { Customer } from '../shared/models/customer';
import { Job } from '../shared/models/job';
import { Transfer } from '../shared/models/transfer';

type SetTransfersForJobParams = {
  job: Job;
  customer?: Customer;
  startDate?: Date;
};

export const setConditionalTransfersForJob = ({
  job,
  customer,
}: {
  job: Job;
  customer?: Customer;
}) => {
  if (
    !customer?.customerTransfers?.transferConditions?.jobTransferConditions?.length
  ) {
    return;
  }

  job.transfers?.forEach((transfer) => {
    const conditionalTransferCheckResult = canTransferJobToCustomer(
      job,
      transfer.targetCustomer.id,
      customer,
    );
    transfer.conditionallyBlocked = !conditionalTransferCheckResult.canTransfer;
    transfer.conditionallyBlockedUntil = conditionalTransferCheckResult.blockedUntil;
  });
};

export const setTransfersForJob = ({
  job,
  customer,
  startDate,
}: SetTransfersForJobParams) => {
  const resolvedStartDate = startDate || (job.date ? new Date(job.date) : undefined);
  if (!resolvedStartDate) {
    return;
  }

  if (customer?.customerTransfers?.transfers?.length && job.shifts?.length) {
    const baseDate = job.date ? new Date(job.date) : resolvedStartDate;
    const jobStartTimeUtc = getUnixTime(
      addTimeZoneOffset(
        addMinutes(
          addHours(baseDate, Math.floor(job.shifts[0].from / 100)),
          job.shifts[0].from % 100,
        ),
      ),
    );

    const jobTransfers: Transfer[] = customer.customerTransfers.transfers.map(
      (customerTransfer) => ({
        transferAt: jobStartTimeUtc - (customerTransfer.redirectOffset || 0),
        targetCustomer: customerTransfer.targetCustomer,
        auto: customerTransfer.auto,
        forceDirectAccept: customerTransfer.forceDirectAccept,
        preventDirectAccept: customerTransfer.forceDirectAccept
          ? false
          : customerTransfer.preventDirectAccept,
        hideDirectAccept: customerTransfer.hideDirectAccept,
        availabilityInfosForAgents: customerTransfer.availabilityInfosForAgents,
      }),
    );
    job.transfers = jobTransfers;
  }

  setConditionalTransfersForJob({ job, customer });
};
